// removed by extract-text-webpack-plugin
module.exports = {"block":"PaymentResult__block-2ATC-","blockFullSize":"PaymentResult__blockFullSize-w_tqm"};